
import { Component, Vue, Prop, Watch } from "vue-property-decorator"

import moment from "moment"

import JobsQuery from "@/graphql/job/jobs.graphql"
import * as cdn from "@coredination/components"
import PlanningFilterDialog from "@/components/dialogs/PlanningFilterDialog.vue"
import EntityEventSubscription from "@/graphql/subscription/entityevent.graphql"
import CountJobs from "@/graphql/job/countJobs.graphql"
import { Formatting } from "../../util/formatting"
const constants = new Formatting.Constants()

@Component({
    components: {
        JobList: () => import("@/components/misc/JobList.vue"),
        PlanningFilterDialog,
    },
    apollo: {
        me: cdn.graphql.me,
        jobs: {
            query: JobsQuery,
                variables() {
                    var params: any = {
                        states: this.defaultJobStates,
                        hideOldFinished: true,
                        from: moment().startOf("day"),
                        to: moment(),
                        onlyLate: true,
                        current: true,
                        filterParams: this.computedFilterParams,
                        offset: this.offset,
                        limit: constants.jobsPerPage,
                    }
                return params
            },
            pollInterval: 300000,
            fetchPolicy: 'no-cache',
        },
        countJobs: {
            query: CountJobs,
            variables() {
                return {
                    states: this.defaultJobStates,
                    hideOldFinished: true,
                    from: moment().startOf("day"),
                    to: moment(),
                    onlyLate: true,
                    current: true,
                    filterParams: this.computedFilterParams,
                    which: this.which
                }
            },
        },
        $subscribe: {
            entityEvent: {
                query: EntityEventSubscription,
                result(result: any) {
                    const event = result.data.entityEvent
                    for (const job of this.jobs) {
                        if (job.uuid == event.data.uuid) {
                            console.log("it's one of my jobs - refreshing")
                            this.refresh()
                            return
                        }
                    }
                },
                skip() {
                    return this.inhibitSubscription
                }
            }
        },
    },
})
export default class LateJobList extends Vue {
    @Prop() uuid!: string
    me: any = {}
    jobs: any = []
    showFilter: boolean = false
    filterText: any = this.$t("planningFilter_listType_mine")
    offset: number = 0

    listTypeFilter: any = {
        type: "list",
        value: "mine",
    }

    defaultJobStates: string[] = [
        "PUBLISHED",
        "ASSIGNED",
        "SCHEDULED",
        "ACCEPTED",
    ]

    filterParams: any = Object.assign({}, {
        type: "list",
        value: "mine",
    })

    mounted() {
        if (sessionStorage && 'lateView' in sessionStorage) {
            var stored: any = JSON.parse(sessionStorage['lateView'])
            if (stored.listTypeFilter)
                this.listTypeFilter = stored.listTypeFilter
            if ((stored.listTypeFilter.type! == 'user' ||
                stored.listTypeFilter.type! == 'group') &&
                stored.listTypeFilter.name)
                this.filterText = stored.listTypeFilter.name
            else if (stored.listTypeFilter.type! == 'list' && stored.listTypeFilter.value)
                this.filterText = this.$t("planningFilter_listType_" + stored.listTypeFilter.value)
        }
    }

    refresh() {
        if (this.$apollo.queries.jobs && typeof this.$apollo.queries.jobs.refetch == "function")
            this.$apollo.queries.jobs.refetch()
    }

    get which(){
        if (this.listTypeFilter?.value){
            const value = this.listTypeFilter.value
            if (value == "mine" || value == "all" || value == "unassigned")
                return value
        }
        return null
    }

    updateOffset(offset: any) {
        this.offset = offset
    }

    changeFilter(filter: any) {
        this.listTypeFilter = filter
        if (sessionStorage) {
            var stored: any = {}
            if ('lateView' in sessionStorage)
                stored = JSON.parse(sessionStorage['lateView'])
            stored['listTypeFilter'] = this.listTypeFilter
            sessionStorage['lateView'] = JSON.stringify(stored)
        }
        if (filter?.type == 'user' && filter?.name) this.filterText = filter.name
        else if (filter?.type == 'group' && filter?.name) this.filterText = filter.name
        else if (filter?.type == 'list' && filter?.value) this.filterText = this.$t("planningFilter_listType_" + filter?.value)
        this.refresh()
    }

    get computedFilterParams() {
        var filterParams: any = Object.assign({}, this.listTypeFilter)
        if ('name' in filterParams)
            delete filterParams.name
        return filterParams
    }

    get calendar() {
        return this.$refs.calendar as Vue & { refresh: () => boolean }
    }

    get inhibitSubscription() {
        return localStorage && !!localStorage.getItem("inhibitSubscription")
    }

    /*
    // This filtering is done in backend in the hql query now, so this shouldn't be needed
    get lateJobs() {
        var filteredJobs = []
        for (const job of this.jobs) {
            if (this.isLate(job)) filteredJobs.push(job)
        }
        return filteredJobs
    }

    isLate(job: any) {
        var state = job.state;
        var startTime = job.startTime;
        var endTime = job.endTime;
        var allDay = job.allDay;
        var stateTracked = job.stateTracked;
        var duration = job.duration;
		if (state == 'INITIAL' || state == 'DRAFT' || state == 'FINISHED' || state == 'CANCELED' || state == 'CLOSED')
			return false;
		if (endTime && new Date().getTime() > endTime + (allDay ? 24*3600000 : 0))
			return true;
        if (!allDay && !endTime && startTime && duration && new Date().getTime() > startTime + duration*60000)
            return true;
        if (stateTracked && (state == 'IN_TRANSIT' || state == 'ON_STATION' || state == 'STARTED' || state == 'PAUSED' || state == 'DAY_FINISHED'))
            return false;
        if (stateTracked && startTime && new Date().getTime() > startTime + (allDay ? 24*3600000 : 0))
            return true;
		return false;
	}
    */
}
